module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_4.87ca0371.png";